export enum Region {
  NSW = 'NSW',
  QLD = 'QLD',
  SA = 'SA',
  VIC = 'VIC',
  WA = 'WA',
  NT = 'NT',
  TAS = 'TAS',
  ACT = 'ACT'
}

export interface PostcodeRange {
  region: string;
  upperRange: number;
  lowerRange: number;
  regionName: string;
}
